import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-12 md:grid-cols-8 grid-cols-1 gap-4 w-full items-center py-4 my-0" }
const _hoisted_2 = { class: "lg:col-span-2 md:col-span-2 col-span-12 flex flex-row md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Nome:", -1)
const _hoisted_4 = { class: "md:text-left truncate" }
const _hoisted_5 = { class: "lg:col-span-1 md:col-span-1 col-span-6 flex flex-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "CRM:", -1)
const _hoisted_7 = { class: "lg:col-span-1 md:col-span-1 col-span-6 flex flex-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "UF:", -1)
const _hoisted_9 = { class: "lg:col-span-1 md:col-span-1 col-span-6 flex flex-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Situação:", -1)
const _hoisted_11 = { class: "lg:col-span-1 md:col-span-1 col-span-12 flex flex-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Inserido em:", -1)
const _hoisted_13 = { class: "lg:col-span-2 md:col-span-1 col-span-6 flex flex-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Por:", -1)
const _hoisted_15 = { class: "lg:col-span-1 col-span-12 hidden lg:flex flex-row" }
const _hoisted_16 = { class: "lg:col-span-2 col-span-6 hidden lg:flex flex-row" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "lg:col-span-1 md:col-span-1 col-span-12 flex flex-row justify-start gap-4 mt-4 md:mt-0" }

import { ref } from 'vue'

import { mdiPlaylistRemove, mdiChevronDoubleUp } from '@mdi/js'
import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'
import { useErrorToast } from '@/composables/useErrorToast'

import UserDisplay from '../AvatarUser/index.vue'
import ConfirmAlert from '@/components/designSystem/Alerts/ConfirmAlert.vue'

interface AuthorizedDoctorDisplayData {
  id: number
  name: string
  crm: string
  crmUf: string
  status: string
  insertedAt: string
  insertedBy: string
  promotedAt: string
  promotedBy: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'TableAuthorizedDsPolicies',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

const policyStore = useDsPolicyStore()
const { notifyError } = useErrorToast()

const showModal = ref(false)
const modalKey = ref(0)
const isLoading = ref(false)
const modalType = ref<'delete' | 'promote'>('delete')
const selectedDoctor = ref<{ id: number; name: string }>({ id: 0, name: '' })

const modalTitle = ref('')
const modalDescription = ref('')

const openModal = (type: 'delete' | 'promote', id: number, name: string) => {
  modalType.value = type
  selectedDoctor.value = { id, name }
  showModal.value = false
  modalKey.value++
  showModal.value = true

  if (type === 'delete') {
    modalTitle.value = 'Confirmar a remoção'
    modalDescription.value = `Você tem certeza que deseja remover ${name} da política?`
  } else {
    modalTitle.value = 'Confirmar a promoção'
    modalDescription.value = `Você tem certeza que deseja promover ${name}?`
  }
}

const handleConfirm = async () => {
  if (!selectedDoctor.value.id) {
    console.error('Nenhum médico selecionado')
    return
  }

  isLoading.value = true

  try {
    if (modalType.value === 'delete') {
      await policyStore.deleteAuthorizedDoctor(selectedDoctor.value.id)
    } else if (modalType.value === 'promote') {
      await policyStore.promoteAuthorizedDoctor(selectedDoctor.value.id)
    }
  } catch (error) {
    notifyError(
      error,
      modalType.value === 'delete'
        ? 'Não foi possível remover o médico da política de restrição.'
        : 'Não foi possível promover o médico na política de restrição.'
    )
    isLoading.value = false
    return
  }

  showModal.value = false
  modalKey.value++

  try {
    const policyId = policyStore.currentPolicy?.id
    if (policyId) await policyStore.fetchAuthorizedDoctorsByDsPolicy(policyId)
  } catch (error) {
    notifyError(error, 'Não foi possível atualizar a lista de médicos autorizados.')
  } finally {
    isLoading.value = false
  }
}



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.data.name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", null, _toDisplayString(_ctx.data.crm), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", null, _toDisplayString(_ctx.data.crmUf), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString(_ctx.data.status), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("p", null, _toDisplayString(_ctx.data.insertedAt), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(UserDisplay, {
            name: _ctx.data.insertedBy
          }, null, 8, ["name"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("p", null, _toDisplayString(_ctx.data.promotedAt || ' '), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.data.promotedBy)
            ? (_openBlock(), _createBlock(UserDisplay, {
                key: 0,
                name: _ctx.data.promotedBy
              }, null, 8, ["name"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_17, " "))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_v_icon, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal('promote', _ctx.data.id, _ctx.data.name))),
            class: "share-icon hover:cursor-pointer",
            color: "primary",
            icon: _unref(mdiChevronDoubleUp)
          }, null, 8, ["icon"]),
          _createVNode(_component_v_icon, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal('delete', _ctx.data.id, _ctx.data.name))),
            class: "share-icon hover:cursor-pointer",
            color: "negative",
            icon: _unref(mdiPlaylistRemove)
          }, null, 8, ["icon"])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(ConfirmAlert, {
      key: modalKey.value,
      showAlert: showModal.value,
      title: modalTitle.value,
      message: modalDescription.value,
      isLoading: isLoading.value,
      onOnCancel: _cache[2] || (_cache[2] = ($event: any) => (showModal.value = false)),
      onOnConfirm: handleConfirm
    }, null, 8, ["showAlert", "title", "message", "isLoading"]))
  ], 64))
}
}

})